import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import homeFill from "@iconify/icons-eva/home-fill";
import unlockFill from "@iconify/icons-eva/unlock-fill";
import personFill from "@iconify/icons-eva/person-fill";
import creditCardFilled from "@iconify/icons-eva/credit-card-fill";
import dollarCircleFilled from "@iconify/icons-ant-design/dollar-circle-filled";
import settings2Fill from "@iconify/icons-eva/settings-2-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import ChangePassword from "./ChangePassword";

// material
import { alpha } from "@mui/material/styles";
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
// components
import MenuPopover from "../../components/MenuPopover";
//
import account from "../../_mocks_/account";
import { logout } from "../../DAL/Login/Login";
import { _get_user_from_localStorage } from "src/DAL/localStorage/localStorage";
import { s3baseUrl } from "src/config/config";
import { get_root_value } from "src/utils/domUtils";
import { ContentSettingApi } from "src/DAL/ContentSetting/ContentSetting";
import moment from "moment";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { allVideoDurationapi } from "src/DAL/Programmes/Programmes";

// import ChangeCard from "src/components/ChangeCard/ChangeCard";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: "Edit Profile",
    icon: personFill,
    linkTo: "/edit-profile",
  },
  // {
  //   label: "Settings",
  //   icon: settings2Fill,
  //   linkTo: "#",
  // },
  {
    label: "Payment Request",
    icon: dollarCircleFilled,
    linkTo: "/payment-request",
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();

  const [openPasswordModal, setopenPasswordModal] = useState(false);
  const [openChangeCard, setOpenChangeCard] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleProfile = (value) => {
    navigate(value);
    handleClose();
  };
  const handlePopup = () => {
    // setOpen(false);
  };

  const { userInfo } = useContentSetting();

  const handleVideoPause = async () => {
    let allVideoList = JSON.parse(localStorage.getItem("video_list"));
    let videoType = localStorage.getItem("video_type");
    let data = { recording_array: allVideoList };

    const result = await allVideoDurationapi(data, videoType);
    if (result.code === 200) {
      localStorage.clear("video_list");
      localStorage.clear("video_type");
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const handleLogout = () => {
    // const formdata = new FormData();
    // formdata.append('token', localStorage.getItem('token'));
    // const result = await logout(formdata);
    // if (result.code === 200) {
    handleVideoPause();
    localStorage.removeItem("user_data");
    localStorage.removeItem("token");
    navigate("/login");
    // } else {
    //   enqueueSnackbar(result.message, { variant: 'error' });
    // }
  };
  const handleChange = () => {
    handleClose();
    navigate(`/dashboard`);
  };
  return (
    <>
      <ChangePassword
        openPasswordModal={openPasswordModal}
        setopenPasswordModal={setopenPasswordModal}
      />
      {/* <ChangeCard
        openChangeCard={openChangeCard}
        setOpenChangeCard={setOpenChangeCard}
      /> */}
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
            color: get_root_value("--portal-theme-primary"),
          }),
        }}>
        {userInfo !== null &&
        userInfo !== undefined &&
        userInfo !== "undefined" ? (
          <Avatar
            src={s3baseUrl + userInfo?.profile_image}
            alt={userInfo?.first_name + " " + userInfo?.last_name}>
            {/* {userInfo?.first_name + userInfo?.last_name} */}
          </Avatar>
        ) : (
          ""
        )}
      </IconButton>

      <MenuPopover
        Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}>
        {userInfo !== null &&
        userInfo !== undefined &&
        userInfo !== "undefined" ? (
          <Box sx={{ my: 1.5, px: 2.5 }} onClick={handleChange} color="inherit">
            <Typography variant="subtitle1" noWrap>
              {userInfo?.first_name + " " + userInfo?.last_name}
            </Typography>
            <Typography variant="body2" noWrap>
              {userInfo?.email}
            </Typography>
          </Box>
        ) : (
          ""
        )}
        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            // to={option.linkTo}
            // component={RouterLink}
            onClick={() => handleProfile(option.linkTo)}
            sx={{ typography: "body2", py: 1, px: 2.5 }}>
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
                color: get_root_value("--portal-theme-primary"),
              }}
            />

            {option.label}
          </MenuItem>
        ))}
        <MenuItem
          key=""
          // to={option.linkTo}
          // component={RouterLink}
          onClick={() => {
            navigate(`/transaction`);
            handleClose();
          }}
          sx={{ typography: "body2", py: 1, px: 2.5 }}>
          <Box
            component={Icon}
            icon={dollarCircleFilled}
            sx={{
              mr: 2,
              width: 24,
              height: 24,
              color: get_root_value("--portal-theme-primary"),
            }}
          />
          Transactions
        </MenuItem>
        {/* <MenuItem
          key=""
          // to={option.linkTo}
          // component={RouterLink}
          onClick={() => {
            navigate(`/manage-card`);
            handleClose();
          }}
          sx={{ typography: "body2", py: 1, px: 2.5 }}
        >
          <Box
            component={Icon}
            icon={creditCardFilled}
            sx={{
              mr: 2,
              width: 24,
              height: 24,
              color: get_root_value("--portal-theme-primary"),
            }}
          />
          Manage Card
        </MenuItem> */}

        <MenuItem
          key=""
          // to={option.linkTo}
          // component={RouterLink}
          onClick={() => {
            handleClose();
            setopenPasswordModal(true);
          }}
          sx={{ typography: "body2", py: 1, px: 2.5 }}>
          <Box
            component={Icon}
            icon={unlockFill}
            sx={{
              mr: 2,
              width: 24,
              height: 24,
              color: get_root_value("--portal-theme-primary"),
            }}
          />
          Change Password
        </MenuItem>

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={() => handleLogout()}>
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}

// {
//   title: "Billing",
//   path: "/billing",
//   icon: getIcon(peopleFill),
// },
// {
//   title: "CreditCard",
//   path: "/creditcard",
//   icon: getIcon(peopleFill),
// },
// {
//   title: "All Transactions",
//   path: "/transaction",
//   icon: getIcon(peopleFill),
// },
